import { PacemEventTarget } from '../eventtarget';
//namespace Pacem.Behaviors{
export class PacemBehavior extends PacemEventTarget {
    #items = new WeakSet();
    register(element) {
        var container = this.#items;
        if (!container.has(element)) {
            container.add(element);
            this.decorate(element);
        }
    }
    unregister(element) {
        var container = this.#items;
        if (container.has(element)) {
            this.undecorate(element);
            container.delete(element);
        }
    }
    has(element) {
        return this.#items.has(element);
    }
}
//}
